module.exports = __webpack_public_path__ + "img/person-forgot.25e12386.png";